import React from "react";
import { Suspense, useEffect, useRef, useState } from "react";
import { useFilters } from "../Filters.hook";
import "./styles.less";
import { Modal } from "shared-components/Components/Modal/web";
import { useKeywordLocation } from "./KeywordLocation.hook";
import { Input } from "antd";
import { LocationOutlinedIcon } from "shared-components/Components/CustomIcons/LocationOutlinedIcon/web";
import { SearchIcon } from "shared-components/Components/CustomIcons/SearchIcon/web";
import { useSearchResultsFilters } from "shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { CloseIcon } from "shared-components/Components/CustomIcons/CloseIcon/web";

export const LocationTagHolder = () => {
    const {filtersTags} = useFilters();
    const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
    const {theme} = useTheme();
    const screen = useWindowSize()
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    const [modalOpen, setModalOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [tags, setTags] = useState([]);

    const {
		keyword,
		onSearch,
		onSelect,
		searchResults,
		searchLoading,
	} = useKeywordLocation({
        className:null,
		searchByProject:false,
		searchByReference:true,
		locations:[],
	});

    const removeNeighborhood = (neighborhoodId) => {
        const neighborhoods = filtersTags?.neighborhood_id;
        const newNeighborhoods = neighborhoods.filter(n => n.value !== neighborhoodId);
        if(neighborhoods.length && !newNeighborhoods.length) {
        changeFiltersAndUpdateURL({
            neighborhood_id: newNeighborhoods ?? [],
            estate_id: null,
        });
        } else {
        changeFiltersAndUpdateURL({
            neighborhood_id: newNeighborhoods ?? [],
        });
        }
    }

    const removeEstate = () => {
        changeFiltersAndUpdateURL({
            estate_id: null,
        });
    }

    const removeSearchstring = () => {
        changeFiltersAndUpdateURL({
            searchstring: null,
        });
    }

    const openModal = () => {
        setModalOpen(true); 
        if(!screen.lg) document?.body?.classList.add('no-scroll'); 
    }

    const closeModal = () => {
        setModalOpen(false);
        document?.body?.classList.remove('no-scroll'); 
    }

    const handleClickOutside = (event) => {
        if(!screen.lg) {
            return false;
        }
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          closeModal()
        }
    };

    const handleEscape = (event) => {
        if (event.key === 'Escape') {
          closeModal()
        }
    };

    const handleSelectLocation = (option) => {
        onSelect(option.name, option);
        setInputValue("");
        closeModal();
    }
    
    useEffect(() => {
        let newTags = [];
        filtersTags?.neighborhood_id?.map(option => {
            newTags.push({
                text: option.text,
                value: option.value,
                onRemove: () => {removeNeighborhood(option.value);onSelect('', {})},
            })
        })

        if(filtersTags?.searchstring) {
            newTags.push ({
                text: filtersTags?.searchstring?.text,
                value: filtersTags?.searchstring?.value,
                onRemove: () => {removeSearchstring();onSelect('', {})},
            })
        }

        if(!filtersTags?.neighborhood_id?.length && filtersTags?.estate_id) {
            newTags.push({
                text: filtersTags?.estate_id?.text,
                value: filtersTags?.estate_id?.value,
                onRemove: () => {removeEstate();onSelect('', {})},
            })
        }

        setTags(newTags);
    }, [filtersTags?.neighborhood_id, filtersTags?.estate_id, filtersTags?.searchstring]);

    useEffect(() => {
        document?.addEventListener('mousedown', handleClickOutside);
        document?.addEventListener('keydown', handleEscape);
        return () => {
            document?.removeEventListener('mousedown', handleClickOutside);
            document?.removeEventListener('keydown', handleEscape);
        };
    }, [screen?.lg]);

    useEffect(() => {
      if (modalOpen) setInputValue("");
    }, [modalOpen]);

    const modalContent = (
        <div className={'location-main-wrapper ' + (screen.lg ? 'desktop' : 'mobile')}>
            <div className="holder">
                {tags.length > 0 &&
                    <div className="tag-holder" style={{display:'flex', gap: 5, flexWrap: 'wrap'}}>
                        {tags.map(e => 
                            <div key={e.value} className="filter-tag"
                                onClick={() => {
                                    e.onRemove();
                                    inputRef?.current?.focus()
                                }}
                            >
                                {e.text}
                                <span className="close">
                                    <CloseIcon width={12} />
                                </span>
                            </div>
                        )}
                    </div>
                }

                <div className="holder-content">
                    <Input 
                        className={tags.length > 0 ?'':'notags'} 
                        ref={inputRef} 
                        autoFocus={true} 
                        onChange={(e) => {
                            onSearch(e.target.value);
                            setInputValue(e.target.value);
                        }}
                        placeholder="Buscá por ubicación o palabra clave"  
                        allowClear={true}
                        onFocus={(e)=>{setInputValue(e.target.value)}}
                        value={inputValue}
                    />
                    
                    {searchLoading &&
                        <span style={{display:'flex', gap: 10, padding: 15}}>
                            <span>
                                <Suspense fallback={<div>...</div>}>
                                    {React.createElement(React.lazy((async () => (await import("@ant-design/icons/LoadingOutlined")))))}
                                </Suspense>
                            </span>

                            Cargando
                        </span>
                    }

                    <div className={"option-list" + (screen.lg ? '' : 'mobile')}>
                        {!searchLoading && inputValue !== '' && searchResults?.searchLocation?.map((option, i) => (
                            <div 
                                className="option"
                                key={i} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', borderBottom: 'solid 1px #dadada', padding: '10px'}}
                                onClick={() => handleSelectLocation(option)}
                            >
                                <span>
                                    <LocationOutlinedIcon width={20} />
                                </span>
                                <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: 10, lineHeight: 1.1}}>
                                    <span>{option.name}{option.__typename === 'Neighborhood' ? ', ' + option.estate?.name: ''}</span>
                                    <span style={{color:'#777'}}>{option.__typename === 'Neighborhood' ? 'Barrio' : 'Departamento'}</span>
                                </div>
                            </div>
                        ))}
                        {!searchLoading && !searchResults?.searchLocation?.length && keyword !== '' && 
                            <div 
                                className="option"
                                style={{display: 'flex', justifyContent: 'center', alignItems: 'center', borderBottom: 'solid 1px #dadada', padding: '10px 5px'}}
                                onClick={() => {
                                    onSelect(keyword, {__typename: 'keyword', name: keyword});
                                    closeModal();
                                }}
                            >
                                <div style={{position: 'relative', top: 2}}>
                                    <SearchIcon color={'#666'} size={20}/>
                                </div>
                                <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: 10, lineHeight: 1.1}}>
                                    <span>{"Buscar inmuebles relacionados a" + " "}<b style={{fontWeight: 'bold'}}>{keyword}</b></span>
                                </div>
                            </div>
                        }
                    </div>

                    {!screen.lg && <div className="apply-button"
                        style={{
                            borderRadius: 10,
                            padding: 10,
                            backgroundColor: theme.colors.primaryColor,
                            color:'white',
                            position: 'absolute',
                            bottom: 10,
                            right: 10,
                            left: 10,
                        }}
                        onClick={() =>{closeModal();}}
                        >
                            <span>Aplicar</span>
                    </div>}
                </div>
            </div>
        </div>
    )

    return (
        <div ref={dropdownRef} style={{position: 'relative'}}>
            {(screen.lg && modalOpen) ? modalContent : null}

            {!modalOpen && <div className="autocompletTagHolder" 
            onClick={() => { openModal()}}
            >
                {tags.length > 0 && 
                    <div className="filter-tag" style={{maxWidth: '70%', cursor: 'pointer'}}>
                        <span style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap'
                            
                        }}>{tags[0].text}</span>
                        <span className="close" onClick={(e) => {e.stopPropagation();tags[0].onRemove()}}>
                            <CloseIcon width={12} />
                        </span>
                    </div>
                }
                {tags.length > 1 && 
                    <div className="filter-tag">
                        {tags.length - 1} más
                    </div>
                }

                <span
                    className="autocomplete-placeholder"
                >
                    Buscá por ubicación o palabra clave
                </span>
            </div>}

            {!screen.lg && <Modal show={modalOpen} onClose={() => { closeModal() }} classes="location-modal" backdropStyles={{padding: 0}}>
               {modalContent}
            </Modal>}
        </div>
    );
}